import MinaPay from './MinaPay'

export {
    MinaPay
}


// WEBPACK FOOTER //
// ./src/components/mina/index.js